import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { TransferPage } from '../transfer/transfer';

/**
 * Generated class for the P2pPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-p2p',
  templateUrl: 'p2p.html',
})
export class P2pPage {

    list: string = 'all';

    all_list: any = [];
    send_list: any = [];
    receive_list: any = [];
	// items: any;
	// max_items: number = 0; 
	// count_items: number = 0;

	loginId: string;
	api_key: string;
	email: string;
	version: string;
	idx: string;
	unit: string;
	coin_unit: string;
	cash_unit: string;
	deposit_unit: string;

    balance: any = [];
    
	bonus_name_one: string;
	bonus_name_two: string;

	// divide: string = '0';
	// divide_name: string;
	// idx: string = '';
	// from: string = '';
	// to: string = '';

	public texts: any = [];
	public language : string;
	
	isButton : boolean = true;
	more_button : boolean = false;
  
	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public alertCtrl: AlertController,
		private http: HttpService,
		public app: App
	) {
        let id = this.navParams.get('id')
        if (id != undefined) {
            this.list = id;
        }
  	}

    ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}
		
		//// 페이지 이름
		localStorage.setItem("pageName", "p2p");

		this.email = localStorage.getItem("email");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.unit = localStorage.getItem("unit");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.cash_unit = localStorage.getItem("cash_unit");
		this.deposit_unit = localStorage.getItem("deposit_unit");
        this.bonus_name_one = localStorage.getItem("bonus_name_one");
        this.bonus_name_two = localStorage.getItem("bonus_name_two");

		this._get_texts();
        // this.list = 'all';
		this._init({divide: this.list, idx: ''});
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).p2p;
		// this.divide_name = this.texts.day_btn;
	}

	_init(data) {
        this._balance();
        
        // this.all_list = undefined;
        // this.send_list = undefined;
        // this.receive_list = undefined;

        let url: string;

        if(data.divide == 'all') {
            url = "p2p/base/index/list";
        } else if(data.divide == 'send') {
            url = "p2p/base/index/list/send";
        } else if(data.divide == 'receive') {
            url = "p2p/base/index/list/receive";
        }

		let body = JSON.stringify({
			api: this.api_key,
			language: this.language,
			version: this.version,
			idx: data.idx,
		});

        this.http.post(url, body).then((res: any) => {
            if (res.result === 'OK'){
                this.idx = res.idx;
                if (res.list !== undefined){
                    if (data.divide == 'all') {
                        if (data.idx == undefined || data.idx == null || data.idx == '') {
                            this.all_list = res.list;
                        } else {
                            let list = this.all_list.concat(res.list);
                            this.all_list = list;
                        }
                    }
                    if (data.divide == 'send') {
                        if (data.idx == undefined || data.idx == null || data.idx == '') {
                            this.send_list = res.list;
                        } else {
                            let list = this.send_list.concat(res.list);
                            this.send_list = list;
                        }
                    }
                    if (data.divide == 'receive') {
                        if (data.idx == undefined || data.idx == null || data.idx == '') {
                            this.receive_list = res.list;
                        } else {
                            let list = this.receive_list.concat(res.list);
                            this.receive_list = list;
                        }
                    }					
                }

            } else if(res.result ==="LOGOUT"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                localStorage.removeItem("loginId");
                localStorage.removeItem("api_key");
                this.app.getRootNav().setRoot(LoginPage);
            
            } else {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
        },(err)=>{	
            //// HTTP 에러인 경우
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
        
        });
	}

    _balance() {
        let url = "p2p/base";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
				this.balance = res.balance;

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{	
			//// HTTP 에러인 경우
			let alert = this.alertCtrl.create({
				message: err.message,
				buttons: ['OK']
			});
			alert.present();
		
		});
    }

    _send() {
        this.navCtrl.push(TransferPage);
    }

	_close() {
		this.navCtrl.pop();
    }
}



// WEBPACK FOOTER //
// ./src/pages/p2p/p2p.ts